import Cookie from 'cookies-js'


export function isLogin(){
  return Cookie.get("rememberMe");
}


export  function fmtDate(row, column, cellValue, index) {
  if (cellValue) {
    return myFormatDate(cellValue, "yyyy-MM-dd");
  } else {
    return ""
  }
}
export  function  fmtDateTime(row, column, cellValue, index) {
  if (cellValue) {
    return myFormatDate(cellValue, "yyyy-MM-dd HH:mm:ss");
  } else {
    return ""
  }
}

export function isEmpty(value){
  if (value == "" || value == null || value == undefined||value=={}||value=="undefined") {
    return true;
  }
  return false;
}
export function formatDate (date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
};


export function myFormatDate(dd,fmt){
  let now = new Date(dd);
  let year = now.getFullYear();
  let month = now.getMonth() + 1;
  let date = now.getDate();
  let hour = now.getHours();
  let minute = now.getMinutes();
  let second = now.getSeconds();
  month=month<10?"0"+month:month;
  date=date<10?"0"+date:date;
  hour=hour<10?"0"+hour:hour;
  minute=minute<10?"0"+minute:minute;
  second=second<10?"0"+second:second;
  if (fmt==="yyyy-MM-dd HH:mm:ss") {
  return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
  }else if (fmt==="yyyy年MM月dd日"){
  return year + "年" + month + "月" + date+"日";
  }else {
  return year + "-" + month + "-" + date;
  }
}

function padLeftZero (str) {
  return ('00' + str).substr(str.length);
};

export function formatDateTimestamp(time) {
  var date = new Date(time);
  return formatDate(date, 'yyyy-MM-dd hh:mm:ss');
};

export default {
  //分页每页数据量设置
  pageSizes: [10, 20, 30, 50],

  //日期时间格式转换
  format: {
    // 转换table单元格中的时间戳为日期字符串
    formatDate: function (timestamp) {
      if (!timestamp)return;
      let date = new Date(parseInt(timestamp));
      let Y = date.getFullYear() + '-';
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
      let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      return Y + M + D;
    },
    //转换table单元格中的时间戳为日期时间字符串
    formatTime: function(timestamp) {
      if (!timestamp)return;
      let date = new Date(parseInt(timestamp));
      let Y = date.getFullYear() + '-';
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
      let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      let m = date.getMinutes()  < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    //将中国标准日期的格式转化为yyyy-MM-dd HH:mm:ss格式，中国标准时间格式：Tue Dec 04 2018 17:06:23 GMT+0800 (中国标准时间)
    formatCHNToTime:function (chnTime) {
      if (!chnTime)return;
      let d = new Date(chnTime);
      let datetime=d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
      return datetime;
    },
    //字符串时间格式化(去掉结尾.0)
    formatTimeString:function (timeStr) {
      if (!timeStr)return;
      let time=timeStr.toString().substring(0,timeStr.length-2);
      return time;
    },
    //字符串时间格式化(去掉结尾.0)
    formatTimeStringNYR:function (timeStr) {
      if (!timeStr)return;
      let time=timeStr.toString().substring(0,10);
      return time;
    },
  },
  //获取系统当前路径
  getRootPath:function () {
    //获取当前网址，如： http://localhost:8088/test/test.jsp
    var curPath = window.document.location.href;
    //获取主机地址之后的目录，如： test/test.jsp
    var pathName = window.document.location.pathname;
    var pos = curPath.indexOf(pathName);
    //获取主机地址，如： http://localhost:8088
    var localhostPath = curPath.substring(0, pos);
    //获取带"/"的项目名，如：/test
    var projectName = pathName.substring(0, pathName.substr(1).indexOf('/') + 1);
    return (localhostPath + projectName);//发布前用此
    //return (localhostPath);//发布后用此

  },

  //锚点定位
  anchor: {
    scrollToAnchor: function (id) {
      document.getElementById(id).scrollIntoView();
    }
  }

}






// WEBPACK FOOTER //
// ./src/util/utils.js